import { Input } from 'semantic-ui-react';
import { FormSection, ToggleField } from './FormSection';
import { Field, FieldGrid, ToggleList } from '../serviceFormStyles';
import { getEffectiveSlugname, isPaidService } from '../serviceFormUtils';

const PaymentSection = ({ inputs, updateInputs, handleInputs, errorInputs, eventNames }) => {
  const isPaidEvent = isPaidService(inputs);

  const togglePaidEvent = () => {
    const baseName = getEffectiveSlugname(inputs).replace(/\./g, '');
    if (isPaidEvent) {
      const restoreSelect = eventNames.some((name) => name === baseName);
      updateInputs({
        newEventSlugname: restoreSelect ? '' : baseName,
        ...(restoreSelect ? { eventSlugname: baseName } : {}),
        paidEvent: '',
        allowPartialPayments: false,
      });
      return;
    }
    updateInputs({ newEventSlugname: `${baseName}.` });
  };

  return (
    <FormSection
      id="pago"
      number={2}
      title="Pago"
      description="Define si el evento tiene costo y cómo se puede pagar."
    >
      <ToggleList>
        <ToggleField
          name="paidEventName"
          label="Evento de pago"
          checked={isPaidEvent}
          onChange={togglePaidEvent}
        >
          <FieldGrid>
            <Field>
              <label htmlFor="paidEvent">Costo del evento</label>
              <Input
                id="paidEvent"
                name="paidEvent"
                type="number"
                min={0}
                label="$"
                placeholder="Ej. 50000"
                value={inputs.paidEvent ?? ''}
                onChange={handleInputs}
                error={Boolean(errorInputs.paidEvent)}
                fluid
              />
              {errorInputs.paidEvent && <p className="field__error">Indica el costo del evento</p>}
            </Field>
          </FieldGrid>
        </ToggleField>
        {isPaidEvent && (
          <ToggleField
            name="allowPartialPayments"
            label="Se puede pagar en dos partes"
            checked={inputs.allowPartialPayments}
            onChange={() => updateInputs({ allowPartialPayments: !inputs.allowPartialPayments })}
            hint="El asistente podrá escoger entre 1 o 2 pagos."
          />
        )}
      </ToggleList>
    </FormSection>
  );
};

export default PaymentSection;
